import { Map, List } from "immutable";
import { PAYMENT_PROGRAM_ACTIONS } from "constants/actions";
import { STATE_STATUS } from "constants/state-status";

const INITIAL_STATE = new Map({
    "1": new Map({
        status: undefined,
        data: List(),
        pages: new Map({}), 
        count: null
    }),
    "3": new Map({
        status: undefined,
        data: new Map({}),
        pages: new Map({}),
        count: null
    }),
    "2": new Map({
        status: undefined,
        data: new Map({}),
        pages: new Map({}),
        count: null
    }),
    current_tab: "1",
    entityDocuments :STATE_STATUS.UNFETCHED,
    caseCheckList : new Map(),
    caseCheckListStatus : STATE_STATUS.UNFETCHED,
});

export default (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
    case PAYMENT_PROGRAM_ACTIONS.FETCH_PAYMENT_PROGRAM_DETAILS:
        return state.setIn([
            payload.requestType,
            "status"
        ], STATE_STATUS.FETCHING)
            .set("current_tab", payload.requestType);
    case PAYMENT_PROGRAM_ACTIONS.FETCHED_PAYMENT_PROGRAM_DETAILS:
        return state
            .setIn([
                payload.requestType,
                "status"
            ], STATE_STATUS.FETCHED)
            .setIn([payload.requestType, "count"], payload.data && payload.data.count)
            .setIn([payload.requestType, "data"], new List((payload.data && payload.data.results)) || List());
    case PAYMENT_PROGRAM_ACTIONS.FAILED_FETCH_PAYMENT_PROGRAM_DETAILS:
        return state
            .setIn([
                payload.requestType,
                "status"
            ], STATE_STATUS.FETCH_FAILED);
    case PAYMENT_PROGRAM_ACTIONS.FETCH_UPDATE_ENTITY_DOCUMENTS:
        return state.set("entityDocuments" , STATE_STATUS.FETCHING);
    case PAYMENT_PROGRAM_ACTIONS.FETCHED_UPDATE_ENTITY_DOCUMENTS : 
        return state.set("entityDocuments" , STATE_STATUS.FETCHED);
    case PAYMENT_PROGRAM_ACTIONS.FAILED_UPDATE_ENTITY_DOCUMENTS:
        return state.set("entityDocuments" , STATE_STATUS.FETCH_FAILED);

    case PAYMENT_PROGRAM_ACTIONS.FETCH_PAYMENT_PROGRAM_ACTION_DETAILS:
        return state
            .setIn(["caseCheckList" , payload.case_id , "status"] , STATE_STATUS.FETCHING)
            .set("caseCheckListStatus" , STATE_STATUS.FETCHING);
    case PAYMENT_PROGRAM_ACTIONS.FETCHED_PAYMENT_PROGRAM_ACTION_DETAILS : 
        return state
            .setIn(["caseCheckList" , payload.case_id , "status"] , STATE_STATUS.FETCHED)
            .setIn(["caseCheckList" , payload.case_id , "data"] , payload.data)
            .set("caseCheckListStatus" , STATE_STATUS.FETCHED);

    case PAYMENT_PROGRAM_ACTIONS.FAILED_FETCH_PAYMENT_PROGRAM_ACTION_DETAILS:
        return state.set("caseCheckListStatus" , STATE_STATUS.FETCH_FAILED);
    
    case "LOGOUT":
        return INITIAL_STATE;
    default:
        return state;
    }
};